export default __webpack_public_path__ + "static/1-de88efd945c45aa5140de059141d8570.png";